import React from 'react';
import { BookOpen, Target, Users, Briefcase, Award } from 'lucide-react';
export function AboutCourse() {
  return <section className="mb-12" data-id="element-50">
      <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-51">
        About the Course
      </h2>

      <div className="prose prose-lg max-w-none mb-8" data-id="element-52">
        <p className="text-gray-700 leading-relaxed mb-6" data-id="element-53">
          The Executive Assistant Mastery Course is a practical, high-impact
          program designed to equip Executive Assistants with the skills,
          confidence, and mindset needed to excel in modern executive support
          roles.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-54">
          Whether you're working with C-suite leaders, entrepreneurs, or busy
          professionals, this course prepares you to move beyond routine admin
          tasks and step into the role of a strategic workplace partner.
        </p>
      </div>

      <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-2xl p-8 border border-blue-100" data-id="element-55">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-56">
          What You'll Learn
        </h3>
        <div className="space-y-4" data-id="element-57">
          <div className="flex items-start gap-4" data-id="element-58">
            <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-59">
              <Users className="w-5 h-5 text-white" data-id="element-60" />
            </div>
            <div data-id="element-61">
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-62">
                Professional Communication Skills
              </h4>
              <p className="text-gray-700" data-id="element-63">
                Engage effectively with executives and stakeholders at all
                levels.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-64">
            <div className="flex-shrink-0 w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-65">
              <Target className="w-5 h-5 text-white" data-id="element-66" />
            </div>
            <div data-id="element-67">
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-68">
                Scheduling and Coordination Mastery
              </h4>
              <p className="text-gray-700" data-id="element-69">
                Manage complex calendars and priorities with confidence.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-70">
            <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-71">
              <Briefcase className="w-5 h-5 text-white" data-id="element-72" />
            </div>
            <div data-id="element-73">
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-74">
                Stakeholder Management Techniques
              </h4>
              <p className="text-gray-700" data-id="element-75">
                Build trust and smooth collaboration across teams.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-76">
            <div className="flex-shrink-0 w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-77">
              <Award className="w-5 h-5 text-white" data-id="element-78" />
            </div>
            <div data-id="element-79">
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-80">
                Decision Support Skills
              </h4>
              <p className="text-gray-700" data-id="element-81">
                Position yourself as a valuable advisor, not just support staff.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-82">
            <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-83">
              <BookOpen className="w-5 h-5 text-white" data-id="element-84" />
            </div>
            <div data-id="element-85">
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-86">
                Real-World Simulations
              </h4>
              <p className="text-gray-700" data-id="element-87">
                Tool-based practice to apply what you learn immediately.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}